
import { AppConfig } from 'src/config/app-config.service';
import { IMapper } from 'src/core/sharepoint/model/mapper';
import { Language } from 'src/core/utility/enums/enums';
import { News } from '../models/news';
import { newsConstants } from './news-const';
import { IMapperPaging } from 'src/core/sharepoint/model/mapperPaging';

export class NewsMapper implements IMapperPaging {
    appSettings=  AppConfig.settings;;

    convertListItems(items: SP.ListItemCollection<any>): News[] {

        let newsItems: Array<News> = new Array<News>();
        if (items != null) {
            let listItemsEnumerator = items.getEnumerator();

            while (listItemsEnumerator.moveNext()) {

                newsItems.push(this.convertItem(listItemsEnumerator.get_current()));
            }
        }
        return newsItems;
    }

    convertItem(item: SP.ListItem<any>): News {
        let news: News = null;
        if (item != null) {
            news = new News();

            news.title = item.get_item(newsConstants.list.fields.title);
            news.brief = item.get_item(newsConstants.list.fields.brief);
            news.description = item.get_item(newsConstants.list.fields.description);
            news.expirationDate = item.get_item(newsConstants.list.fields.expirationDate);
            news.modifiedDate = item.get_item(newsConstants.list.fields.modifiedDate);     
            news.picture = item.get_item(newsConstants.list.fields.picture);
            news.url= newsConstants.slash + Language[_spPageContextInfo.currentLanguage] + this.appSettings.newsDetailsPageUrl +"?id="+item.get_item(newsConstants.list.fields.id);
        }
        return news;
    }
    
    convertListItemsPaging(data: any): any {

        let result:any = {};
        result.Items = new Array<News>();
        if (data.items != null) {
            let listItemsEnumerator = data.items.getEnumerator();

            while (listItemsEnumerator.moveNext()) {

                result.Items.push(this.convertItem(listItemsEnumerator.get_current()));
            }
        }
        result.hasNext = data.hasNext;
        return result;
    }
    
    
    GetData(item: any): string {
        if (item != null) {
            var arr: string[] = new Array();
            for (let index = 0; index < item.length; index++) {

                arr.push(item[index].get_lookupValue());
            }
            return arr.join(',')
        }
        return "";
    }
}
